export function debounce<T extends (...args: any[]) => any>(cb: T, wait = 200): (...args: Parameters<T>) => void {
  let h: NodeJS.Timeout | null = null
  const callable = (...args: Parameters<T>): void => {
    clearTimeout(h)
    h = setTimeout(() => cb(...args), wait)
  }
  return callable
}
